module.exports = __webpack_public_path__ + "img/artFuture.1d99ecee.gif";